import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mantine/core';

import DefaultModuleLayout from './DefaultModuleLayout';
import TrainingSidebar from '../navigation/TrainingSidebar';
import { useAppConfig } from '../../hooks/useAppConfig';
import { getIsTrainingModuleEnabled } from '../../constants/navigation';
import Loader from '../common/Loader';
import When from '../common/When';

function TrainingLayout() {
    const { trainingModuleEnabled, loading } = useAppConfig();
    const isEnabled = getIsTrainingModuleEnabled(trainingModuleEnabled);

    useEffect(() => {
        localStorage.setItem('selectedModule', 'Training');
    }, []);

    return (
        <When
            condition={loading}
            fallback={
                <When
                    condition={!isEnabled}
                    fallback={
                        <DefaultModuleLayout>
                            <TrainingSidebar />
                            <Box className="w-full bg-light-grey overflow-x-hidden overflow-y-scroll pl-[78px] h-[calc(100vh-64px)]">
                                <Outlet />
                            </Box>
                        </DefaultModuleLayout>
                    }
                >
                    <Navigate to="/dashboard" replace />
                </When>
            }
        >
            <DefaultModuleLayout>
                <div className="flex justify-center items-center h-[calc(100vh-64px)] w-full">
                    <Loader />
                </div>
            </DefaultModuleLayout>
        </When>
    );
}

export default TrainingLayout;
